import React, { useMemo } from 'react'
import { Form as FormilyForm } from '@formily/antd'
import { usePrefix, DnFC, useDesigner, TreeNodeWidget } from '@designable/react'
import { createForm } from '@formily/core';
import { AntdNavBar } from '../NavBar/NavBar'
import { AntdSideBar } from '../SideBar/sideBar'
import { AntdTabBar } from '../TabBar/tabBar'
import { observer } from '@formily/reactive-react'

interface FromProps {
  showNav?: boolean;
  navBarProps?: any;
  showSideBar?: boolean;
  sideBarProps?: any;
  showTabBar?: boolean;
  tabBarProps?: any;
}

export const Form: DnFC<React.ComponentProps<typeof FormilyForm> & FromProps> = 
  observer((props) => {
    const prefix = usePrefix('designable-mobile-form')
    const form = useMemo(
      () =>
        createForm({
          designable: true,
        }),
      []
    )

    const navBarProps = props.navBarProps || {};
    const sideBarProps = props.sideBarProps || {};
    const tabBarProps = props.tabBarProps || {};
    return (
      <FormilyForm
        {...props}
        style={{ ...props.style, height: '100%' }}
        className={prefix}
        form={form}
      >
        {props?.showNav && <AntdNavBar {...navBarProps} style={{ zIndex: 2, ...navBarProps.style }} >{navBarProps.title}</AntdNavBar>}
        {props?.showSideBar ? 
          <div style={{ flex: 1, display: 'grid', overflow: 'hidden', gridTemplateColumns: "105px 1fr" }}>
            <AntdSideBar {...sideBarProps} style={{ zIndex: 2, ...sideBarProps.style }} />
            <div style={{ overflowY: 'auto', height: '100%'}}>
              {props.children}
            </div>
          </div> :
          <div style={{ overflowY: 'auto', flex: 1}}>
            {props.children}
          </div>
        }
        {props?.showTabBar && (
          <AntdTabBar
            {...tabBarProps}
            style={{ zIndex: 2, ...tabBarProps.style }}
          />
        )}
        
      </FormilyForm>
    )
  })
